import React from 'react';

import { useCitySelectedContext } from '../../../../contexts/city-context/CityContext';
import { useMediaQuery, WIDE_DESKTOP } from '../../../core/hooks/useMediaQuery';
import { FooterContentEntity } from '../../domain/entities/FooterContentEntity';
import styles from '../styles/Footer.module.scss';

import FooterBrandSectionCmp from './FooterBrandSectionCmp';
import FooterFeaturesCmp from './FooterFeaturesCmp';
import FooterLegalInfoCmp from './FooterLegalInfoCmp';
import FooterSocialMediaCmp from './FooterSocialMediaCmp';

interface FooterViewCmpProps {
  footer_data?: FooterContentEntity;
  has_fare_estimate_button: boolean;
}

function FooterViewCmp({
  footer_data,
  has_fare_estimate_button,
}: Readonly<FooterViewCmpProps>): React.ReactElement {
  const isDesktop = useMediaQuery(WIDE_DESKTOP);
  const { query_params } = useCitySelectedContext();

  const footerClasses = has_fare_estimate_button
    ? `${styles['footer-container']} ${styles['with-extra-padding']}`
    : styles['footer-container'];

  return (
    <footer className={footerClasses}>
      <div className={styles['footer-content-wrapper']}>
        <div className={styles['company-info']}>
          <FooterBrandSectionCmp
            footer_data={footer_data}
            isDesktop={isDesktop}
            query_params={query_params}
          />
          <FooterFeaturesCmp
            footer_data={footer_data}
            query_params={query_params}
          />
        </div>
        <FooterLegalInfoCmp footer_data={footer_data} />
        <div className={styles['social-media-mobile-container']}>
          <FooterSocialMediaCmp
            socialMediaLinks={footer_data?.social_links.social_media_links}
          />
        </div>
      </div>
    </footer>
  );
}

export default FooterViewCmp;
